module.exports = __webpack_public_path__ + "img/download-app-1.2bd562de.png";